import React from "react";
import { observer } from "mobx-react-lite";
import { Timeline, Space, Typography } from "antd";
import WorkbenchWidgetCard from "./WorkbenchWidgetCard";
import { useWorkbenchStore } from "../stores/context";
import { ActionStatus } from "../../tasks/types";
import { SyncOutlined, WarningTwoTone } from "@ant-design/icons";
import AlphaIdLabel from "../../tasks/components/AlphaIdLabel";
import { Utils } from "../../common/misc/Utils";

const ActionsHistoryWidget: React.FC = () => {
    const { workbenchStore } = useWorkbenchStore();

    const getTimelineDot = (status: ActionStatus) => {
        switch (status) {
            case "Completed":
                return { color: "green" };
            case "Failed":
                return { color: "red" };
            case "Started":
                return {
                    dot: <SyncOutlined spin style={{ fontSize: "16px" }} />,
                };
            default:
                return {
                    dot: (
                        <WarningTwoTone
                            twoToneColor="#ffc300"
                            style={{ fontSize: "16px" }}
                        />
                    ),
                };
        }
    };

    const renderActionsContent = () => {
        if (!workbenchStore.actionsHistoryData.length) {
            return <div>No actions history found</div>;
        }

        const timelineItems = workbenchStore.actionsHistoryData.map(
            (action, index) => ({
                key: index,
                children: (
                    <div>
                        <div>
                            <Space>
                                <span>
                                    {Utils.formatDateStringShort(
                                        action.triggeredOn,
                                    )}
                                </span>
                                <span style={{ fontWeight: 500 }}>
                                    {action.actionName || "Unknown Action"}
                                </span>
                            </Space>
                        </div>
                        <div>
                            <Space>
                                {action.alphaId ? (
                                    <AlphaIdLabel alphaId={action.alphaId} />
                                ) : null}
                                <Typography.Link
                                    href={`${window.location.origin}/tasks/${action.taskId}`}
                                    target="_blank"
                                >
                                    {action.taskTitle}
                                </Typography.Link>
                            </Space>
                        </div>
                    </div>
                ),
                ...getTimelineDot(action.status),
            }),
        );

        return (
            <Timeline
                items={timelineItems}
                style={{ margin: -6, padding: 16 }}
            />
        );
    };

    return (
        <WorkbenchWidgetCard
            title="Actions History"
            widgetState={workbenchStore.actionsHistoryWidget}
        >
            {renderActionsContent()}
        </WorkbenchWidgetCard>
    );
};

export default observer(ActionsHistoryWidget);
